const MIN_CHARS_FOR_SEARCH = 3;

export const isSearchValueValid = (searchValue: string): boolean => {
  return searchValue.length >= MIN_CHARS_FOR_SEARCH;
};
